import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AddAuctionComponent } from './add-auction/add-auction.component';
import { AuctionListComponent } from './auction-list/auction-list.component';
import { ViewAuctionComponent } from './view-auction/view-auction.component';
import { BackUrlResolver } from '../../shared/resolver/back-url.resolver';
import { AuctionResultComponent } from './auction-result/auction-result.component';
import { ImportedUsersComponent } from './imported-users/imported-users.component';

const routes: Routes = [
  {
    path: '', component: AuctionListComponent,
  },
  {
    path: 'add',
    component: AddAuctionComponent,
  },
  {
    path: ':id',
    children: [
      {
        path: '',
        component: ViewAuctionComponent,
      },
      {
        path: 'edit',
        component: AddAuctionComponent,
      },
      {
        path: 'users',
        loadChildren: () => import('./auction-user/auction-user.module').then(m => m.AuctionUserModule),
        resolve: { returnTo: BackUrlResolver },
      },
      {
        path: 'configure-lot',
        loadChildren: () => import('./configure-lot/configure-lot.module').then(m => m.ConfigureLotModule),
      },
      {
        path: 'bids',
        loadChildren: () =>
          import('./bids/bids.module').then((m) => m.BidsModule),
      },
      {
        path: 'result',
        component: AuctionResultComponent,
      },
      {
        path: 'imported-users',
        component: ImportedUsersComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuctionRoutingModule { }
